const namespace = "COURSELIVECLASSES_";

const CONSTANTS = {
  LIVECLASSES_VIDEOSDATA_GET: `${namespace}VIDEOSDATA_GET`,
  LIVECLASSES_NEWSERVICE_VIDEOSDATA_GET: `${namespace}NEWSERVICE_VIDEOSDATA_GET`,
  LIVECLASSES_VIDEOSDATA_LOADING: `${namespace}VIDEOSDATA_LOADING`,
  LIVECLASSES_VIDEOSDATA_SUCCESS: `${namespace}VIDEOSDATA_SUCCESS`,
  LIVECLASSES_VIDEOSLIST_SUCCESS: `${namespace}VIDEOSLIST_SUCCESS`,
  LIVECLASSES_VIDEOSDATA_ERROR: `${namespace}VIDEOSDATA_ERROR`,

  LIVECLASSES_BEFOREDATA_GET: `${namespace}BEFOREDATA_GET`,
  LIVECLASSES_BEFOREDATA_LOADING: `${namespace}BEFOREDATA_LOADING`,
  LIVECLASSES_BEFOREDATA_SUCCESS: `${namespace}BEFOREDATA_SUCCESS`,
  LIVECLASSES_BEFOREDATA_ERROR: `${namespace}BEFOREDATA_ERROR`,

  LIVECLASSES_DELETEDATA_DELETE: `${namespace}DELETEDATA_DELETE`,
  LIVECLASSES_DELETEDATA_LOADING: `${namespace}DELETEDATA_LOADING`,
  LIVECLASSES_DELETEDATA_SUCCESS: `${namespace}DELETEDATA_SUCCESS`,
  LIVECLASSES_DELETEDATA_ERROR: `${namespace}DELETEDATA_ERROR`,

  LIVECLASSES_MODALDATA_GET: `${namespace}MODALDATA_GET`,
  LIVECLASSES_MODALDATA_LOADING: `${namespace}MODALDATA_LOADING`,
  LIVECLASSES_MODALDATA_SUCCESS: `${namespace}MODALDATA_SUCCESS`,
  LIVECLASSES_MODALDATA_ERROR: `${namespace}MODALDATA_ERROR`,

  LIVECLASSES_MODALSTATE_TOGGLE: `${namespace}MODALSTATE_TOGGLE`,
  LIVECLASSES_DELETEMODALSTATE_TOGGLE: `${namespace}DELETEMODALSTATE_TOGGLE`,

  LIVECLASSES_ACTIVESESSION_ID: `${namespace}ACTIVESESSION_ID`,
  LIVECLASSES_ACTIVESESSION_ISAGORA: `${namespace}ACTIVESESSION_ISAGORA`,

  LIVECLASS_CLEARDATA: `${namespace}CLEARDATA`,
};

export default CONSTANTS;
